import { ViewOptionsInterface } from 'pf-frontend-common/dist/module/view/options.interface';
import { domQuerySelector } from 'pf-frontend-common/src/helper/dom/query-selector';
import { BrowserViewport } from 'pf-frontend-common/src/module/browser/viewport';
import { DataKeyValueStringInterface } from 'pf-frontend-common/src/module/data/key-value/string.interface';
import { DomElementEvent } from 'pf-frontend-common/src/module/dom/element.event';
import { ViewBasicInterface } from 'pf-frontend-common/src/module/view/basic.interface';

import { MintagaBuildingReviewsButtonStatsGtmClick } from 'common/module/building-review/mintaga-review/gtm/cta-click';
import { MintagaBuildingReviewsStatsGtmImpression } from 'common/module/building-review/mintaga-review/gtm/impression';
import { MintagaReviewHtmlElementInterface } from 'common/module/building-review/mintaga-review/html-element.interface';
import { StatsGtmProviderInterface } from 'common/module/stats/gtm/provider.interface';

export class MintagaReviewView implements ViewBasicInterface {
  /**
   * Main HTML element
   */
  private element: HTMLElement;

  /**
   * View id (is needed for browser viewport service)
   */
  private id: string = 'MintagaReviewView';

  /**
   * View html elements
   */
  private htmlElement: MintagaReviewHtmlElementInterface;

  /**
   * Whether impression is collected
   * Impression should be collected only when user sees widget
   * in viewport for the FIRST time
   */
  private impressionCollected: boolean = false;

  /**
   * Whether cta click is collected
   *
   * Should be collected only when user clicked on impression for the first time
   */
  private ctaCollected: boolean = false;

  /**
   * CSS Selectors
   */
  private readonly cssSelector: DataKeyValueStringInterface = {
    mintagaBuildingReviewsButton: '[data-qs=mintaga-building-reviews-button]',
  };

  /**
   * Constructor
   */
  constructor(private statsGtm: StatsGtmProviderInterface, private browserViewport: BrowserViewport) {}

  /**
   * @inheritDoc
   */
  public initialize(options: ViewOptionsInterface): void {
    this.element = options.element;

    this.htmlElement = {
      mintagaBuildingReviewsButton: domQuerySelector(this.element, this.cssSelector.mintagaBuildingReviewsButton),
    };

    // Attach observers
    this.observers();
  }

  /**
   * @inheritDoc
   */
  public render(): void {
    return;
  }

  /**
   * Attach observers
   */
  private observers(): void {
    this.htmlElement.mintagaBuildingReviewsButton.addEventListener('click', this.onClickMintagaReviewButton);

    this.browserViewport.registerWatcher(this.id, this.element);

    this.browserViewport
      .getEventEmitter()
      .addListener(DomElementEvent.enterViewport, this.onEnterMintagaReviewViewport);
  }

  /**
   * Click on cta button
   */
  private onClickMintagaReviewButton = () => {
    if (this.ctaCollected) {
      return;
    }

    this.statsGtm.send(MintagaBuildingReviewsButtonStatsGtmClick);

    this.ctaCollected = true;
  };

  /**
   * Widget is in viewport
   */
  private onEnterMintagaReviewViewport = (id: string) => {
    if (id !== this.id || this.impressionCollected) {
      return;
    }

    this.statsGtm.send(MintagaBuildingReviewsStatsGtmImpression);

    this.impressionCollected = true;
  };
}
